import { render, staticRenderFns } from "./ArtistListPage.vue?vue&type=template&id=1714c7e2&"
import script from "./ArtistListPage.vue?vue&type=script&lang=js&"
export * from "./ArtistListPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports